var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityWaterSupply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -1035.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Water-supply",
    transform: "translate(2734.000000, 1035.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.208,6 L9.208,0 C9.208,0 14.416,0 14.416,4 L14.416,6 L16.5,6 C25.875,6 29,9 29,18 L20.666,18 C20.666,15 19.625,14 16.5,14 L4,14 L4,6 L9.208,6 Z M20.666,27.993 C20.666,25 24.833,20 24.833,20 C24.833,20 29,25 29,27.993 C29,30 26.916,32 24.833,32 C22.528,32 20.666,30 20.666,27.993 L20.666,27.993 Z",
    id: 70
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityWaterSupply);
export default __webpack_public_path__ + "static/media/transport-and-utility-water-supply.261de09d.svg";
export { ForwardRef as ReactComponent };